import React from 'react';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow } from 'material-ui/Table';
import cn from 'classnames';
import { EmptyView } from '../../empty-view';

import './data-grid.css';

export const DataGrid = props => {
	const { columns, className, children, items } = props;
	if (items.length === 0) {
		return <EmptyView />;
	}
	return (
		<Table className={cn('table articles-table', className)}>
			<TableHeader displaySelectAll={false} adjustForCheckbox={false}>
				<TableRow style={{ border: 0 }}>
					{columns.map((column, index) => (
						<TableHeaderColumn
							key={`header-${index}`}
							className={cn('table--cell table--cell-th', column.className)}
							style={{ width: column.width }}
						>
							{column.title}
						</TableHeaderColumn>
					))}
				</TableRow>
			</TableHeader>
			<TableBody displayRowCheckbox={false} showRowHover stripedRows>
				{children}
			</TableBody>
		</Table>
	);
};

export const NativeDataGrid = props => {
	const { columns, className, children, items } = props;
	if (items.length === 0) {
		return <EmptyView />;
	}
	return (
		<table className={cn('table articles-table native-data-grid', className)}>
			<thead>
				<tr style={{ border: 0 }}>
					{columns.map((column, index) => (
						<th key={`header-${index}`} className="table--cell table--cell-th" style={{ width: column.width }}>
							{column.title}
						</th>
					))}
				</tr>
			</thead>
			{children}
		</table>
	);
};



// WEBPACK FOOTER //
// src/components/ui/data-grid/data-grid.jsx